// src/Components/MainLayout.js

import React from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const MainLayout = () => {
  return (
    <>
      <Helmet defaultTitle="MSB Association UK" titleTemplate="%s | MSB Association UK">
        <meta property="og:site_name" content="MSB Association UK" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Header />
      <main>
        {/* The Outlet component will render the matched child route's component */}
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;